import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportActivities = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9319 3.4375H8.93188C6.72275 3.4375 4.93188 5.22836 4.93188 7.4375V17.4375C4.93188 19.6466 6.72275 21.4375 8.93188 21.4375H12.9319",
			stroke: "#2B313A",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.068 12.4375L9.29568 12.4375",
			stroke: "#2B313A",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2957 15.9375L8.79565 12.4375L12.2957 8.9375",
			stroke: "#2B313A",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgReportActivities;
